<template>
  <div>
    <div ref="pageLayout" class="widget flex">
      <div
        v-for="p in pages"
        :key="p.pageNumber"
        :class="[
          'widget-page text-center pr-2 mt-1',
          p.pageNumber > 1
            ? isMobileLayout
              ? 'ml-4 pl-2'
              : 'ml-6 pl-2'
            : 'ml-2',
          p.isSelected ? 'widget-page__selected' : '',
          isMobileLayout ? 'widget-page__mobile pt-3' : 'pt-5',
        ]"
        @click="onPageClick(p.pageNumber)"
      >
        {{ p.pageNumber }}
      </div>
    </div>
  </div>
</template>
<script>
import { forEach, range } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";

export default {
  props: {
    nbPage: {
      type: Number,
      default: 2,
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      width: 0,
      height: 0,
      selectedPage: 0,
    };
  },
  computed: {
    pages() {
      const pages = [];
      const nums = range(this.nbPage);
      forEach(nums, (num) => {
        pages.push({
          pageNumber: num + 1,
          isSelected: num + 1 === this.selectedPage,
        });
      });

      return pages;
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
  watch: {
    isMobileLayout() {
      this.setPageLayout();
    },
  },
  mounted() {
    this.setPageLayout();
    this.selectedPage = this.page;
  },
  methods: {
    onPageClick(selectedPage) {
      this.selectedPage = selectedPage;
      this.$emit("emit-selected-page-change", selectedPage - 1);
    },
    setPageLayout() {
      this.$refs.pageLayout.style.width = `${
        this.nbPage * (this.isMobileLayout ? 26 : 32)
      }px`;
      this.$refs.pageLayout.style.height = `${this.isMobileLayout ? 25 : 30}px`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.widget {
  border-radius: 20px;
  background-color: $color-on-primary;
  box-sizing: border-box;
  font-family: "Arial Regular", "Arial", "sans-serif";
  color: #333333;
  text-align: center;
  line-height: normal;
  border: 1px solid grey;
}
.widget-page {
  width: 26px;
  height: 26px;
  border-radius: 20px;
  box-sizing: border-box;
  font-family: "Arial Regular", "Arial", sans-serif;
  text-align: center;
  line-height: normal;
  font-size: 13px;
}
.widget-page__mobile {
  width: 21px;
  height: 21px;
}
.widget-page__selected {
  background-color: $color-primary;
  color: $color-on-primary;
}
.widget-page:hover {
  cursor: pointer;
}
</style>
